import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_component = _resolveComponent("search-component")!

  return (_openBlock(), _createBlock(_component_search_component, {
    objects: this.pages,
    placeholder: this.placeholder,
    service: $data.service,
    onOpenSearch: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('openSearch')))
  }, null, 8 /* PROPS */, ["objects", "placeholder", "service"]))
}